<script>
    import {query} from "svelte-pathfinder";
    import {setCookie} from "../../../lib/cookie";
</script>


<div class="absolute top-16 right-0 bottom-0 left-0 overflow-y-auto">

    <!-- TODO implement Login Page -->
    <h2>Register</h2>

    {#if $query.processing}
    <p>Processing...</p>
    {:else}
    <a href="/api/auth/signin"
       on:click={() => setCookie('register', '1', 1)}
       rel="external"
       class="relative inline-flex items-center rounded-md border border-transparent bg-indigo-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-800">
        <!-- Heroicon name: mini/plus -->
        <svg class="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
        </svg>
        <span>Sign In</span>
    </a>
    {/if}

</div>


<style></style>